import React, { useState, useEffect } from 'react';
import { withStyles, Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import ErasedCard from './Card/ErasedStorages'
import TotalCard from './Card/TotalStorages'
import HeaderCard from './Card/HeaderCard'

import ShreddedStorages from './Card/ShreddedStorages'
import NotErasedCard from './Card/NotErasedStorages'
import RegisteredDevice from './ChartStatistic'
import InProgress from './Card/InProgress'
import NotErased from './Card/NotErased'
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import SdCard from '@material-ui/icons/SdCard';
import { Memory, Storage, DesktopWindows } from '@material-ui/icons';
import * as actions from './store/overviewActions'
import { colors } from '@material-ui/core';
import moment from 'moment'
import momentTimezone from 'moment-timezone';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    rootGrid: {
        width: `100%`,
        bottom: 0,
        overflow: 'hidden',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            marginLeft: '12px',
            width: '100%'
        }
    },
    progressBarr: {
        width: '100%',
        height: 5
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        display: '-webkit-box'
    },
    form: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    grid: {
        paddingBottom: 0
    }
});


const Overview = props => {
    const { classes, fetchStatistic, activeCustomer, overviews, translations, permissions, hideOptions, fromKPI, refetchTab, setRefetchTab } = props;
    const [overview, setOverview] = useState(overviews);
    const [loading, setLoading] = useState(true);
    const [dateRangeValue, setDateRangeValue] = useState(null);

    useEffect(() => {
        const customerTimezone = window.localStorage.getItem("CustomerTimezone") ?? 'UTC';

        const from = momentTimezone.tz(moment().subtract(7, 'days').set({
            hours: 0,
            minutes: 0,
            seconds: 0
        }), customerTimezone);

        const to = momentTimezone.tz(moment(), customerTimezone);
        
        setDateRangeValue({
            From: from,
            To: to,
            maxDate: to.set({
                hours: 23,
                minutes: 59,
                seconds: 59,
            })
        });
        // eslint-disable-next-line
    }, [ activeCustomer ]);

    useEffect(() => {
        const fetchData = async () => {
            let data = await fetchStatistic({ ActiveCustomerID: activeCustomer, From: dateRangeValue?.From.format('YYYY-MM-DD'), To: dateRangeValue?.To.format('YYYY-MM-DD') });
            setLoading(false);
            setOverview(data);
        };

        dateRangeValue && fetchData();
        return () => {
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCustomer, fetchStatistic, dateRangeValue]);

    const registerDevice = [{
        value: overview.mobile,
        label: translations['mobile'] || "Mobile",
        icon: <PhoneIphoneIcon />,
        color: colors.deepPurple[600]
    }, { value: overview.storage, label: translations['storage'] || "Storage", icon: <Storage />, color: colors.cyan[600] }, {
        value: overview.display,
        label: translations['display'] || "Display",
        icon: <DesktopWindows />,
        color: colors.brown[600]
    }, { value: overview.pc, label: translations['pc'] || "PC", icon: <LaptopMacIcon />, color: colors.green[700] }];
    const storagesType = [{
        value: overview.hdd,
        label: translations['hdd'] || "HDD",
        icon: <Memory />,
        color: colors.amber[600]
    }, { value: overview.ssd, label: translations['ssd'] || "SSD", icon: <SdCard />, color: colors.lightGreen[600] }];

    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={1}
                className={classes.rootGrid}
                item
                alignItems='center'
            >
                <Grid
                    className={classes.grid}
                    item
                    xs={12}
                >
                    <HeaderCard hideOptions={hideOptions} fromKPI={fromKPI} refetchTab={refetchTab} setRefetchTab={setRefetchTab} translations={translations} loading={loading} setOverview={setOverview} setLoading={setLoading}
                        fetchStatistic={fetchStatistic} activeCustomer={activeCustomer}
                        permissions={permissions} numberOfStorages={overview.totalStorages} />
                </Grid>

                <Grid
                    item
                    xs={12}
                    md={6}
                >
                    <TotalCard translations={translations} loading={loading} numberOfStorages={overview.totalStorages} />
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={6}
                >
                    <NotErased translations={translations} loading={loading} numberOfStorages={overview.notErased} />
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={6}
                >
                    <InProgress translations={translations} loading={loading} numberOfStorages={overview.inProgress} />
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={6}
                >
                    <ErasedCard translations={translations} loading={loading} numberOfStorages={overview.erasedStorages} />
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={6}
                >
                    <ShreddedStorages translations={translations} loading={loading} numberOfStorages={overview.shreddedStorages} />
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={6}
                >
                    <NotErasedCard translations={translations} loading={loading} numberOfStorages={overview.failedStorages} />
                </Grid>
                <Grid
                    item
                    lg={6}
                    xl={6}
                    xs={12}
                    sm={10}
                    md={6}
                >
                    <RegisteredDevice translations={translations} loading={loading} registerDevice={registerDevice} title={translations['registered_devices'] || "Registered devices"} />
                </Grid>
                <Grid
                    item
                    lg={6}
                    md={6}
                    sm={10}
                    xl={6}
                    xs={12}
                >
                    <RegisteredDevice translations={translations} loading={loading} registerDevice={storagesType} title={translations['storages'] || "Storages"} />
                </Grid>
            </Grid>

        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        overviews: state.statistic.overview.overviews,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchStatistic: (id) => dispatch(actions.listStatisticOverview(id))
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(Overview));
